<template>
  <button :class="classes" :disabled="isLoading || disabled" v-bind="$attrs"
          :type="type"
          v-on="$listeners">
<!--    <img v-if="isLoading" :src="loadingIcon" alt="loading" style="height: 20px">-->
    <i v-if="isLoading" class="fas fa-spinner fa-spin"></i>
    <slot v-else/>
  </button>
</template>

<script>
import loadingIcon from "@/assets/images/loading.svg";

export default {
  name: "Button",
  props: {
    variant: {
      type: String,
      default: "primary"
    },
    size: {
      type: String,
      default: "md"
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "button"
    }
  },
  computed: {
    classes() {
      return ["btn", `btn-${ this.variant }`, `btn-${ this.size }`, this.disabled && "text-[#ccc]"]
    }
  },
  data: () => ({
    loadingIcon,
  })
}
</script>
